import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Layout from '@/views/layout/Layout'

export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index') },
  { path: '/smsAuth', name: "smsAuth", component: () => import('@/views/login/smsAuth') },
  // 没菜单默认显示
  { path: '/default', component: Layout, children: [{ path: 'index', component: () => import('@/views/default/index') }] }
]

export const asyncRouterMap = [
]

export default new VueRouter({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  linkActiveClass: 'is-active'
})
